<template>
  <el-form ref="formRef" :model="form" class="company-info_form" label-width="120px"
           :label-position="getIsMobile?'top':'right'">
    <el-row :gutter="20">
      <el-col :span="8">
        <el-form-item label="公司名">
          <el-input placeholder="请选择公司名" type="text" v-model="form.dscompany" clearable/>
        </el-form-item>
        <el-form-item label="接受人">
          <el-input ref="inputRef" placeholder="请选择接受人" type="text" v-model="form.dsname" clearable>
            <el-button slot="prepend" @click.native="handleContact">请选择</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="部门">
          <el-input placeholder="请输入部门" type="text" v-model="form.dsbumen"/>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="电话">
          <el-input placeholder="请输入电话" type="text" v-model="form.dstel"/>
        </el-form-item>
        <el-form-item label="手机">
          <el-input placeholder="请输入手机号" type="text" v-model="form.dsphone"/>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="传真">
          <el-input placeholder="请输入传真" type="text" v-model="form.dsmax"/>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input placeholder="请输入邮箱" type="text" v-model="form.dsemail"/>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import useRootSetting from '@/hooks/useRootSetting'
import { defineComponent, reactive ,ref,watch,toRefs} from '@vue/composition-api'

export default defineComponent({
  components: {},
  props: {
    companyInfo: {
      type: Object,
      default: () => {}
    },
    allInfo: {
      type: Object,
      default: () => {}
    },
    flag: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const { getIsMobile } = useRootSetting()
    const defaultForm = () => ({
      dscompany: '',
      dsname: '',
      dsbumen: '',
      dstel: '',
      dsphone: '',
      dsmax: '',
      dsemail: ''
    })
    const form = reactive(defaultForm())
    const formRef = ref(null)
    const showContact = ref(false)

    //选完报价公司给公司名赋值
    watch(()=>props.companyInfo, (data)=> {
       form.dscompany = data.name
    },{immediate:true,deep:true})

    //清掉公司名，其余信息都被清除
    watch(()=>form.dscompany, (val)=> {
      if(val === '') Object.assign(form,defaultForm())
    },{immediate:true,deep:true})

    //清掉接受人，除公司信息其余信息都被清除
    watch(()=>form.dsname, (val)=> {
      if(val === '') {
        Object.assign(form, {
          ...defaultForm(),
          dscompany: form.dscompany // 保留 dscompany 现有值
        })
      }else {
        emit('handleFlag',false)
      }
    },{immediate:true,deep:true})
    const reactiveInfo = toRefs(props.allInfo);
    //选完联系人给所有信息赋值
    watch(()=>reactiveInfo, (val)=> {
       Object.assign(form,val)
    },{immediate:true,deep:true})

    //展示接收人的联系人弹窗
    const handleContact = () => {
      showContact.value = true
      emit('handleContact',showContact.value)
    }
    return {
      formRef,
      form,
      getIsMobile,
      showContact,
      handleContact
    }
  }
})
</script>
